









































import { Component, Vue } from "vue-property-decorator";
import Dashboard from "./components/Dashboard.vue";

@Component({
  components: {
    Dashboard
  }
})
export default class App extends Vue {
  width = 0;
  menuExtended = false;

  mounted() {
    this.width = window.innerWidth;
    console.log("mount: " + this.width);
    this.menuExtended = !this.isMobile();
    window.addEventListener("resize", () => (this.width = window.innerWidth));

let ctx = this
    this.$router.afterEach(function(to, from){
      console.log("after eah called from: " + from.name + ", to: " + to.name)
      if(!ctx.menuExtended){
        console.log("hide menu")
        return
      }
      ctx.extendMenu()
      })
  }


  extendMenu() {
    this.menuExtended = !this.menuExtended;
  }

  showMenu() {
    if (this.isMobile() && !this.menuExtended) {
      return "none";
    }
    return "block";
  }

  getYear() {
    return new Date().getFullYear();
  }

  isMobile() {
    if (this.width < 800) {
      return true;
    }
    return false;
  }
}
